'use client'
import React from 'react'

import { Theme } from '../../themes'
import { Config, ConfigProvider } from '../ConfigProvider'
import { ThemeProvider } from '../ThemeProvider'
import { GlobalStyles } from './GlobalStyles'

export interface GyymUiProviderProps {
  theme?: Theme
  config?: Config
  disableReset?: boolean
  children: React.ReactNode
}

export const GyymUiProvider = ({
  theme,
  config,
  disableReset,
  children,
}: GyymUiProviderProps) => (
  <ConfigProvider config={config}>
    <ThemeProvider theme={theme}>
      {!disableReset && <GlobalStyles />}
      {children}
    </ThemeProvider>
  </ConfigProvider>
)
